!((document, Drupal, once, $) => {

  'use strict';

  /**
   * Handle fun fact node
   */
  Drupal.behaviors.nodeFunFact = {

    attach: function (context) {

      // eslint-disable-next-line max-len
      $(once('nodeFunFact', '.node--type-fun-fact', context)).each(function () {
        let $statCount = $(this).find('.js-stat-count').first();
        if ($statCount) {
          $statCount.html($statCount.html().replace(/(\+)/g, '<span class="highlight uk-text-emphasis">$1</span>'));
        }
      });

    },

  };
  // eslint-disable-next-line no-undef
})(document, Drupal, once, jQuery);
